export const DEFAULT_LOCALE = 'en-US';

export const Locales = [
  ['ar-AE', 'Arabic'],
  ['zh-CN', 'Chinese (Simplified)'],
  ['nl-NL', 'Dutch'],
  ['en-US', 'English'],
  ['fr-CA', 'French'],
  ['de-DE', 'German'],
  ['it-IT', 'Italian'],
  ['ja-JP', 'Japanese'],
  ['pl-PL', 'Polish'],
  ['pt-BR', 'Portuguese'],
  ['es-MX', 'Spanish - Mexico'],
  ['es-ES', 'Spanish - Spain'],
  ['sv-SE', 'Swedish'],
  ['tr-TR', 'Turkish'],
];

export const Regions = [
  ['na', 'North America'],
  ['eu', 'Europe'],
  ['cn', 'China'],
  ['fe', 'Far East'],
];
